export default __webpack_public_path__ + "static/media/mobBannerDAD_AUS.7c91646d.jpg";